// @ts-nocheck
import React from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { fetchGroupChatRooms } from "../../store/actions/groupMessagingActions";
import useGroupMessagingEvents from "../socketEvents/groupMessaging/useGroupMessagingEvents";

const useGroupMessaging = () => {

  // state variables start...
  const [isRenderedOnce, setIsRenderedOnce] = React.useState(false);
  // state variables end...

  // redux hooks start...
  const dispatch = useDispatch();
  // redux hooks end...

  // react-router hooks start...
  const location = useLocation();
  // react-router hooks end...

  // custom hooks start...
  useGroupMessagingEvents({
    global: true
  });
  // custom hooks end...

  // useEffect start...
  React.useEffect(() => {
    if (location.pathname === "/event/chat") {
      return;
    }

    if (!isRenderedOnce) {
      dispatch(
        fetchGroupChatRooms({})
      );
      setIsRenderedOnce(true);
    }
  }, [location, isRenderedOnce]);

  // React.useEffect(() => {
  //   dispatch(
  //     fetchUnreadMsgChatRoomsCountAction()
  //   )
  // }, []);
  // useEffect end...
};

export default useGroupMessaging;